if (!customElements.get('christmas-preorder-agreement')) {
  customElements.define('christmas-preorder-agreement', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.observer) return;

        this.form = this.closest('form');
        this.checkbox = this.querySelector('[data-christmas-preorder-checkbox]');
        this.scope = this.closest('product-info') || this.form;

        if (!this.form || !this.checkbox) return;

        try {
          this.variants = JSON.parse(
            this.querySelector('[data-christmas-preorder-variants]').textContent
          );
        } catch (_) {
          this.variants = {};
        }

        this.lastVariantId = undefined;

        this.onChange = () => this.update();

        this.onSubmit = (event) => {
          this.update();

          if (
            this.currentVariant &&
            (!this.requiresAgreement || this.checkbox.checked)
          ) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          if (this.requiresAgreement) {
            this.checkbox.focus();
            this.checkbox.reportValidity();
          }
        };

        this.onClick = (event) => {
          if (
            event.target.closest?.(
              'button[type="submit"], input[type="submit"]'
            )
          ) {
            this.onSubmit(event);
          }
        };

        this.scope.addEventListener('change', this.onChange);
        this.form.addEventListener('submit', this.onSubmit, true);
        this.form.addEventListener('click', this.onClick, true);

        this.observer = new MutationObserver(() => this.update());

        this.observer.observe(this.scope, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'value', 'class', 'aria-disabled']
        });

        this.update();
      });
    }

    update() {
      const variantId = this.form.querySelector('[name="id"]')?.value;

      this.currentVariant = this.variants[variantId];
      this.requiresAgreement =
        this.currentVariant?.requiresAgreement !== false;

      // Require fresh consent when the selected variant changes.
      if (variantId !== this.lastVariantId) {
        this.checkbox.checked = false;
        this.lastVariantId = variantId;
      }

      // Do not send preorder agreement properties for in-stock purchases.
      if (!this.requiresAgreement) {
        this.checkbox.checked = false;
      }

      if (
        this.classList.contains('hidden') !== !this.requiresAgreement
      ) {
        this.classList.toggle('hidden', !this.requiresAgreement);
      }

      if (this.hidden !== !this.requiresAgreement) {
        this.hidden = !this.requiresAgreement;
      }

      if (this.checkbox.disabled !== !this.requiresAgreement) {
        this.checkbox.disabled = !this.requiresAgreement;
      }

      if (this.checkbox.required !== this.requiresAgreement) {
        this.checkbox.required = this.requiresAgreement;
      }

      const pending =
        this.requiresAgreement && !this.checkbox.checked;

      this.form.toggleAttribute(
        'data-christmas-preorder-pending',
        pending
      );

      const available = this.currentVariant?.available === true;

      const otherPending = Array.from(
        this.scope.querySelectorAll('[data-order-acknowledgement]')
      ).some((input) => {
        const warning = input.closest('[data-order-warning]');

        return (
          warning &&
          !warning.hidden &&
          !warning.classList.contains('hidden') &&
          !input.disabled &&
          !input.checked
        );
      });

      this.form.querySelectorAll(
        'button[type="submit"], input[type="submit"]'
      ).forEach((button) => {
        if (pending || !this.currentVariant) {
          button.dataset.christmasPreorderLock = 'true';

          if (!button.disabled) {
            button.disabled = true;
          }
        } else if (
          button.dataset.christmasPreorderLock === 'true' &&
          available &&
          !otherPending &&
          !button.classList.contains('loading')
        ) {
          delete button.dataset.christmasPreorderLock;

          if (button.disabled) {
            button.disabled = false;
          }

          button.removeAttribute('aria-disabled');
        }
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.form?.removeEventListener('click', this.onClick, true);
      this.observer = null;
    }
  });
}